"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterStrToObj = void 0;
/**
 * Maps a filter string (e.g. a=b|c=d) to an object representation.
 *
 * @param filterStr
 * @returns {{name: (*|string), value: (*|string)}[]}
 */
const filterStrToObj = (filterStr) => {
    return filterStr.split(/\|/g).map(x => {
        const details = x.split(/=/);
        return {
            name: details[0],
            value: details[1]
        };
    });
};
exports.filterStrToObj = filterStrToObj;
//# sourceMappingURL=filterStrToObj.js.map